import React from 'react'
import TypingAnimation from './TypingAnimation'
import '../css/HeaderCard.css'
import AboutPng from '../img/about.png'
// import Navbar from './Navbar'

const HeaderCard = () => {
    return (
        <div className="headerCardContainer">
            <div className="card1 text-center text-info h4">
                <div className="cardTitle">
                    <h1 >Sajjat Hossain</h1>
                    <TypingAnimation />
                </div>
            </div>
            

            <div className="card2 text-center text-info h4">
                <div className="p5 card-title">
                    <img src={AboutPng} type="image/png" className="cardImg" alt="aboutImg" />
                </div>
            </div>
        </div>
        
    )
}

export default HeaderCard
